<template>
  <div class="noRecord">
    <div class="contents">
      <span class="icon_no_record"></span>
      <span class="title">{{Message}}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["Message"],
  data () {
    return {
    }
  }
}
</script>

<style scoped>
  .noRecord {
    width: 100%;
    height: 18rem;
    position: relative;
  }
  .contents {
    position: absolute;
    top: 60%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .icon_no_record {
    display: block;
    width: 5rem;
    height: 5rem;
    background: url("../assets/images/no_record.png") center no-repeat;
    background-size: 5rem 5rem;
    margin: 0 auto;
  }
  .title {
    margin-top: 1rem;
    height: 2rem;
    line-height: 2rem;
    text-align: center;
    display: block;
    font-size: 1.2rem;
    color: #bfbfbf;
  }
</style>



// WEBPACK FOOTER //
// src/components/NoRecord.vue